function buildStepButtons(index, total, tour) {
  const buttons = [];
  const isFirst = index === 0;
  const isLast = index === total - 1;

  if (!isFirst) {
    buttons.push({
      text: "Back",
      classes: "shepherd-button-secondary",
      action() {
        return tour?.back();
      }
    });
  }

  buttons.push({
    text: isLast ? "Done" : "Next",
    action() {
      return isLast ? tour?.complete() : tour?.next();
    }
  });

  return buttons;
}

function isMobileViewport() {
  try {
    return window.matchMedia("(max-width: 767.98px)").matches;
  } catch (_error) {
    return false;
  }
}

function resolveStepPlacement(step) {
  if (isMobileViewport()) {
    return step.mobilePlacement || "bottom";
  }
  return step.placement || "bottom";
}

function buildStepTitle(step, index, total) {
  const baseTitle = step.title || "Tour Step";
  return baseTitle;
}

function buildStepText(step, index, total) {
  const container = document.createElement("div");

  const progress = document.createElement("div");
  progress.textContent = `Step ${index + 1} of ${total}`;
  progress.className = "small text-muted mb-1";

  const description = document.createElement("div");
  description.textContent = step.description || "";

  container.append(progress, description);
  return container;
}

export function buildShepherdSteps(definitions, tour) {
  const visibleSteps = definitions.filter(
    (step) => !!document.querySelector(step.selector)
  );

  return visibleSteps.map((step, index) => ({
    id: `tour-step-${index + 1}`,
    title: buildStepTitle(step, index, visibleSteps.length),
    text: buildStepText(step, index, visibleSteps.length),
    attachTo: {
      element: step.selector,
      on: resolveStepPlacement(step)
    },
    buttons: buildStepButtons(index, visibleSteps.length, tour)
  }));
}

function reportStorageError(action, key, error) {
  // Keep storage failures non-blocking, but visible during development.
  if (import.meta.env.DEV) {
    console.warn(`[tour] Failed to ${action} storage key "${key}".`, error);
  }
}

export function hasSeenTour(key) {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch (error) {
    reportStorageError("read", key, error);
    return false;
  }
}

export function markTourSeen(key) {
  try {
    window.localStorage.setItem(key, "1");
  } catch (error) {
    reportStorageError("write", key, error);
  }
}

export function clearTourSeen(...keys) {
  try {
    keys.forEach((key) => window.localStorage.removeItem(key));
  } catch (error) {
    reportStorageError("clear", keys.join(","), error);
  }
}
